<template>
  <div class="position-header">
    <navHeader :titleList="['个人中心']" />
    <div class="common-padding">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>个人资料</span>
            </div>
            <ul class="person-info">
              <li>
                <div><i class="el-icon-user-solid"></i> 登录名称：</div>
                <div></div>
              </li>
              <li>
                <div><i class="el-icon-phone"></i> 手机号码：</div>
                <div></div>
              </li>
              <li>
                <div><i class="el-icon-message"></i> 邮箱地址：</div>
                <div></div>
              </li>
              <li>
                <div><i class="el-icon-time"></i> 创建时间：</div>
                <div></div>
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col :span="16">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>基本资料</span>
            </div>
            <el-row  type="flex" justify="center">
              <el-col :span="18">
                <el-form class="basic-form" :model="form" label-width="140px">
                  <el-form-item label="用户名称：">
                    <el-input v-model.trim="name"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号码：">
                    <el-input v-model.trim="phone"></el-input>
                  </el-form-item>
                  <el-form-item label="邮箱：">
                    <el-input v-model.trim="email"></el-input>
                  </el-form-item>
                  <el-form-item label="性别：">
                     <el-radio-group v-model="form.sex">
                      <el-radio label="0">男</el-radio>
                      <el-radio label="1">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <div class="info-footer">
                    <el-button type="primary" @click="save" class="el-icon-check">保存</el-button>
                    <el-button @click="back" class="el-icon-refresh-left">关闭</el-button>
                  </div>
                </el-form>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'

export default {
  data () {
    return {
      form: {
        name: '',
        sex: '',
        email: '',
        phone: ''
      }
    }
  },
  components: {
    navHeader
  },
  methods: {
    save () {},
    back () {
      this.$router.push('home')
    }
  }
}
</script>
<style lang="less" scoped>
.person-info {
  margin-top: 30px;
  li {
    display: flex;
    justify-content: space-between;
    padding: 15px 0;
    border-top: 1px solid #ddd;
  }
}
.basic-form {
  .el-form-item {
    margin-bottom: 20px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/person/index.vue